import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      systemNotify: {
        list: [],
        loaded: false,
        requesting: false
      },
      like: {
        list: [],
        loaded: false,
        requesting: false
      },
      reply: {
        list: [],
        loaded: false,
        requesting: false
      },
      redPoint: {
        notify: false,
        reply: false,
        like: false
      }
    };
  },
  mutations: {
    /**
     * 添加系统通知
     */
    concatSystemNotify: function concatSystemNotify(state, list) {
      var _a;

      (_a = state.systemNotify.list).push.apply(_a, __spread(list));
    },

    /**
     * 是否全部加载
     */
    setSystemNotifyLoaded: function setSystemNotifyLoaded(state, loaded) {
      state.systemNotify.loaded = loaded;
    },

    /**
     * 是否正在加载
     */
    setSystemNotifyReq: function setSystemNotifyReq(state, req) {
      state.systemNotify.requesting = req;
    },

    /**
     * 添加点赞
     */
    concatLike: function concatLike(state, list) {
      var _a;

      (_a = state.like.list).push.apply(_a, __spread(list));
    },

    /**
     * 是否全部加载
     */
    setLikeLoaded: function setLikeLoaded(state, loaded) {
      state.like.loaded = loaded;
    },

    /**
     * 是否正在加载
     */
    setLikeReq: function setLikeReq(state, req) {
      state.like.requesting = req;
    },

    /**
     * 添加回复
     */
    concatReply: function concatReply(state, list) {
      var _a;

      (_a = state.reply.list).push.apply(_a, __spread(list));
    },

    /**
     * 是否全部加载
     */
    setReplyLoaded: function setReplyLoaded(state, loaded) {
      state.reply.loaded = loaded;
    },

    /**
     * 是否全部请求
     */
    setReplyReq: function setReplyReq(state, req) {
      state.reply.requesting = req;
    },

    /**
     * 记录红点
     */
    setRedPoint: function setRedPoint(state, redpoint) {
      state.redPoint = redpoint;
    }
  },
  actions: {
    /**
     * 获取通知
     */
    getSystemNotify: function getSystemNotify(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var lastId = _b.lastId,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.systemNotify;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
              }

              commit('setSystemNotifyReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/system_notice/notice_list', {
                params: {
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatSystemNotify', rdata.data);

                if (rdata.data.length < count) {
                  commit('setSystemNotifyLoaded', true);
                }
              }

              commit('setSystemNotifyReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 点赞列表
     */
    getLike: function getLike(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var lastId = _b.lastId,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.like;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
              }

              commit('setLikeReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/system_notice/like_list', {
                params: {
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                list.forEach(function (item) {
                  item.id = item.like_id;
                });
                commit('concatLike', list);

                if (list.length < count) {
                  commit('setLikeLoaded', true);
                }
              }

              commit('setLikeReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 回复列表
     */
    getReply: function getReply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var lastId = _b.lastId,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.reply;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && wrap.list.length > 0) {
                lastId = undefined;
                wrap.loaded = false;
                wrap.list = [];
              }

              commit('setReplyReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/system_notice/reply_list', {
                params: {
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatReply', list);

                if (rdata.data.length < count) {
                  commit('setReplyLoaded', true);
                }
              }

              commit('setReplyReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 是否有红点
     */
    checkRedPoint: function checkRedPoint(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/system_notice/check')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRedPoint', {
                  notify: rdata.data.notice,
                  reply: rdata.data.reply,
                  like: rdata.data.like
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;